module.exports = __webpack_public_path__ + "static/img/tick.5bf44d1b.png";